import { get } from '@core/api/baseApi';
import ReportsSource, { reportsBasePath } from '../types/ReportsSource';

// Through baseApi (not a plain fetch) so the auth headers are attached. The
// series is a hint that saves the API a lookup for legacy DICOM reports.
const getStudyReportContent = (
  source: ReportsSource,
  sopInstanceUid: string,
  seriesInstanceUid?: string | null,
): Promise<Blob> =>
  get<Blob>(`${reportsBasePath(source)}/${sopInstanceUid}/content`, {
    responseType: 'blob',
    params: seriesInstanceUid ? { series: seriesInstanceUid } : undefined,
  });

export default getStudyReportContent;
